export default __webpack_public_path__ + "static/screeny-130-ga-scheda-tecnica-77438b0ec25b214158a362908cfda29c.pdf";